import { useMutation, useQueryClient } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const updateTagsMediasToQualify = async ({ old_tags, new_tags, medias }) => {
  const body = {
    add: new_tags.filter((tag) => !old_tags.includes(tag)),
    delete: old_tags.filter((tag) => !new_tags.includes(tag)),
    medias: medias.map((media) => media.id),
  };

  const response = await axiosInstance.patch('/medias/tags/', body);
  return response.data;
};

export const useUpdateTagsMediasToQualify = (options = {}) => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    ...options,
    mutationFn: updateTagsMediasToQualify,
    onSuccess: (data, variables) => {
      // Invalide le cache pour forcer un refetch des données
      queryClient.invalidateQueries({ queryKey: ['tags'] });
      queryClient.invalidateQueries({ queryKey: ['medias'] });

      options.onSuccess?.(data, variables);
    },
    onError: (error, variables) => {
      console.error('Mutation error:', error);
      options.onError?.(error, variables);
    },
  });

  return {
    updateTagsMediasToQualify: mutation.mutateAsync,
    isLoading: mutation.isPending,
    isError: mutation.isError,
    isSuccess: mutation.isSuccess,
    error: mutation.error,
    data: mutation.data,
  };
};
